module.exports = __webpack_public_path__ + "img/candela-client-integration-light-01.f5d8b268.png";